import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { continueApplicationApi } from './ContinuePageActions';

export class ContinuePage extends Component {
    static propTypes = {
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    render() {
        return (<div />);
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(spinnerOpen());
        dispatch(trackTransition('pp_credit_stepup_decision', 'prepare_pp_credit_stepup_decision'));
        return dispatch(continueApplicationApi());
    }
});

export default connect(null, mapDispatchToProps)(ContinuePage);
